import { type DealCloseSummaryResponse } from "@vega-api/generated/types/dealCloseSummaryResponse";
import { Notice, NoticeType } from "@vega-core/components/Notice/Notice";
import { m } from "@vega-core/paraglide/messages";
import { formatMoneyShort } from "@vega-core/utils/formatMoney";

type CloseDealSummaryProps = {
  summary: DealCloseSummaryResponse;
};

export const CloseDealSummary = ({ summary }: CloseDealSummaryProps) => {
  const {
    finalRaise,
    targetRaise,
    committedLpCount,
    openIndicativeOrderCount,
    warnings,
  } = summary;

  const stats = [
    {
      testId: "close-deal-summary-finalRaise",
      label: m.coInvestments_closeDeal_summary_finalRaise(),
      value: formatMoneyShort(finalRaise),
    },
    {
      testId: "close-deal-summary-targetRaise",
      label: m.coInvestments_closeDeal_summary_targetRaise(),
      value: formatMoneyShort(targetRaise),
    },
    {
      testId: "close-deal-summary-committedLps",
      label: m.coInvestments_closeDeal_summary_committedLps(),
      value: committedLpCount,
    },
    {
      testId: "close-deal-summary-openOrders",
      label: m.coInvestments_closeDeal_summary_openOrders(),
      value: openIndicativeOrderCount,
    },
  ];

  return (
    <div className="flex flex-col gap-4" data-testid="close-deal-summary">
      <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-border/primary bg-border/primary">
        {stats.map((stat) => (
          <div
            className="bg-background/primary p-3"
            data-testid={stat.testId}
            key={stat.testId}
          >
            <dt className="body-small-regular text-text/secondary">
              {stat.label}
            </dt>
            <dd className="body-base-semibold text-text/primary">
              {stat.value}
            </dd>
          </div>
        ))}
      </dl>

      {warnings.length > 0 ? (
        <div className="flex flex-col gap-2" data-testid="close-deal-warnings">
          {warnings.map((warning) => (
            <Notice
              content={warning.message}
              key={warning.type}
              type={NoticeType.WARNING}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};
